import React, { useEffect } from "react";
import ParticipantForm from "../components/AddParticipant/ParticpantForm";

const AddParticipant = () => {
    useEffect(() => {
        document.title = "Add New Participant"
    }, []);

    return (
        <div className="row justify-content-center">
            <div className="column-medium-10">
                <ParticipantForm />
            </div>
        </div>
    )

}
export default AddParticipant;
